// Generated by purs version 0.13.0
"use strict";
var Chip_Action = require("../Chip.Action/index.js");
var Chip_Model_DieReason = require("../Chip.Model.DieReason/index.js");
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var tick = function (level) {
    var ticked = {
        ticksLeft: Data_Functor.map(Data_Maybe.functorMaybe)(function (v1) {
            return v1 - 1 | 0;
        })(level.ticksLeft),
        tick: level.tick + 1 | 0,
        blocks: level.blocks,
        chipsLeft: level.chipsLeft,
        enemies: level.enemies,
        hint: level.hint,
        inventory: level.inventory,
        player: level.player,
        tiles: level.tiles,
        trapConnections: level.trapConnections
    };
    if (Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(level.ticksLeft)(new Data_Maybe.Just(1))) {
        return Chip_Action.withAction(ticked)(new Chip_Action.Die(Chip_Model_DieReason.Timed.value));
    };
    if ((level.tick - level.player.turnedAt | 0) > 4) {
        return Chip_Action.inactive({
            player: {
                direction: Chip_Model_Direction.Down.value,
                movedAt: ticked.player.movedAt,
                pos: ticked.player.pos,
                turnedAt: ticked.player.turnedAt
            },
            blocks: ticked.blocks,
            chipsLeft: ticked.chipsLeft,
            enemies: ticked.enemies,
            hint: ticked.hint,
            inventory: ticked.inventory,
            tick: ticked.tick,
            ticksLeft: ticked.ticksLeft,
            tiles: ticked.tiles,
            trapConnections: ticked.trapConnections
        });
    };
    return Chip_Action.inactive(ticked);
};
module.exports = {
    tick: tick
};
